const staff = [
    {key:1,text:'นพ.ไชยยุทธ ธนไพศาล',value:1},
    {key:2,text:'นพ.ณรงชัย ว่องกลกิจศิลป์',value:2},
    {key:3,text:'นพ.ผาติ อังคสิทธิ์',value:3},
    {key:4,text:'นพ.ภาณุ ธีรตกุลพิศาล',value:4},
    {key:5,text:'พญ.ปาริชาติ ตันมิตร',value:5},
    {key:6,text:'พญ.สุภัชชา ประเสริฐเจริญสุข',value:6},
    {key:7,text:'นพ.นันท์นภัส เกตดาว',value:7}

]

const staff_search = [
    {key:99,text:'ทั้งหมด',value:99},
    {key:1,text:'นพ.ไชยยุทธ ธนไพศาล',value:1},
    {key:2,text:'นพ.ณรงชัย ว่องกลกิจศิลป์',value:2},
    {key:3,text:'นพ.ผาติ อังคสิทธิ์',value:3},
    {key:4,text:'นพ.ภาณุ ธีรตกุลพิศาล',value:4},
    {key:5,text:'พญ.ปาริชาติ ตันมิตร',value:5},
    {key:6,text:'พญ.สุภัชชา ประเสริฐเจริญสุข',value:6},
    {key:7,text:'นพ.นันท์นภัส เกตดาว',value:7}
]

module.exports = { staff,staff_search }
